// extracted by mini-css-extract-plugin
export default {"img-btn":"BackArrow_img-btn__gq-jJ"};